(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('hg-cookie-label')) {
    customElements.define('hg-cookie-label', class extends HTMLElement {
      connectedCallback() {
        this.openPreferences = (event) => {
          const link = event.target.closest?.('a[href="#shopifyReshowConsentBanner"]');
          if (!link) return;
          const conceptBanner = document.getElementById('CookieBanner');
          if (conceptBanner?.showCookiePreferences) {
            event.preventDefault();
            event.stopImmediatePropagation();
            conceptBanner.showCookiePreferences();
            return;
          }
          if (!window.privacyBanner?.showPreferences) return;
          event.preventDefault();
          window.privacyBanner.showPreferences().catch((error) => {
            console.warn('Cookie settings could not be opened.', error);
          });
        };
        document.addEventListener('click', this.openPreferences, true);
        this.updateLabel = () => {
          const bodyLabel = this.dataset.bodyLabel;
          const previousBodies = ["Auch wir machen diese Sache mit den Cookies. Ein paar sind nötig. Weitere nutzen wir nur mit deinem OK: für einen besseren Shop und passende Angebote, auch außerhalb unseres Shops.", "We do the cookie thing too. A few are essential. We only use others with your OK: for a better shop and relevant offers, including outside our shop.", "Machen wir auch. Einige braucht unser Shop, damit alles funktioniert. Andere helfen uns mit deiner Zustimmung zu verstehen, was dir gefällt, und dir passende Werbung zu zeigen.", "Auch bei uns gibt’s Cookies. Einige braucht unser Shop, damit alles funktioniert. Mit deinem Okay nutzen wir weitere, um den Shop zu verbessern und dir passende Werbung zu zeigen."];
          if (bodyLabel) {
            for (const paragraph of document.querySelectorAll('#shopify-pc__banner p')) {
              const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
              while (walker.nextNode()) {
                const node = walker.currentNode;
                if (node.parentElement?.closest('a, button, svg, [aria-hidden="true"]')) continue;
                for (const previousBody of previousBodies) {
                  if (node.nodeValue.includes(previousBody)) {
                    node.nodeValue = node.nodeValue.replace(previousBody, bodyLabel);
                  }
                }
              }
            }
          }
          const labels = [
            { selector: ':is(h2,h3)', label: this.dataset.headingLabel },
            { selector: '.shopify-pc__banner__btn-manage-prefs', label: this.dataset.settingsLabel },
            { selector: '.shopify-pc__banner__btn-accept', label: this.dataset.acceptLabel },
            { selector: '.shopify-pc__banner__btn-decline', label: this.dataset.declineLabel }
          ];
          for (const { selector, label, previous } of labels) {
            const button = document.querySelector(`#shopify-pc__banner ${selector}`);
            if (!button || !label) continue;
            const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
            let labelWritten = false;
            while (walker.nextNode()) {
              const node = walker.currentNode;
              const value = node.nodeValue.trim();
              if (!value || node.parentElement?.closest('svg, [aria-hidden="true"]')) continue;
              if (previous && value !== previous) continue;
              const replacement = labelWritten ? '' : label;
              if (value !== replacement) node.nodeValue = node.nodeValue.replace(value, replacement);
              labelWritten = true;
            }
            const ariaLabel = button.getAttribute('aria-label');
            if (ariaLabel && (!previous || ariaLabel === previous) && ariaLabel !== label) {
              button.setAttribute('aria-label', label);
            }
          }
          const banner = document.querySelector('#shopify-pc__banner');
          if (!banner) return;
          const accept = banner.querySelector('.shopify-pc__banner__btn-accept');
          const decline = banner.querySelector('.shopify-pc__banner__btn-decline');
          const settings = banner.querySelector('.shopify-pc__banner__btn-manage-prefs');
          const actions = accept?.parentElement;
          if (!actions || decline?.parentElement !== actions || settings?.parentElement !== actions) return;

          const nativePrivacy = banner.querySelector('#shopify-pc__banner__body-policy-link');
          const fallbackPrivacy = banner.querySelector('.hg-cookie-privacy');
          let privacy = nativePrivacy || fallbackPrivacy;
          if (nativePrivacy && fallbackPrivacy && nativePrivacy !== fallbackPrivacy) fallbackPrivacy.remove();
          if (!privacy && this.dataset.privacyUrl && this.dataset.privacyLabel) {
            privacy = document.createElement('a');
            privacy.href = this.dataset.privacyUrl;
          }
          if (privacy && this.dataset.privacyLabel) {
            privacy.classList.add('hg-cookie-privacy');
            if (privacy.textContent !== this.dataset.privacyLabel) privacy.textContent = this.dataset.privacyLabel;
            if (privacy.hasAttribute('aria-label') && privacy.getAttribute('aria-label') !== this.dataset.privacyLabel) {
              privacy.setAttribute('aria-label', this.dataset.privacyLabel);
            }
          }

          // Move existing nodes so Shopify's click handlers and the tab order are preserved.
          [accept, decline, settings, privacy].filter(Boolean).forEach((control, index) => {
            if (actions.children[index] !== control) actions.insertBefore(control, actions.children[index] || null);
          });
        };
        this.observer = new MutationObserver((records) => {
          const bannerChanged = records.some((record) => {
            const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            if (target && target.closest('#shopify-pc__banner')) return true;
            return Array.from(record.addedNodes).some((node) =>
              node.nodeType === 1 &&
              (node.matches('#shopify-pc__banner') || node.querySelector('#shopify-pc__banner'))
            );
          });
          if (bannerChanged) this.updateLabel();
        });
        this.observer.observe(document.body, { childList: true, subtree: true, characterData: true });
        this.updateLabel();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('click', this.openPreferences, true);
      }
    });
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-home-trust"] && !Shopify.designMode) return;
  try {
    
  const hgHomeReviewRoots = new WeakSet();
  function hgHomeReviewCounter(root) {
    if (hgHomeReviewRoots.has(root)) return;
    hgHomeReviewRoots.add(root);
    const refresh = () => {
      const rating = root.querySelector('.jdgm-all-reviews-rating');
      const score = root.querySelector('.jdgm-all-reviews-rating__score');
      const text = root.querySelector('.jdgm-all-reviews-text__text');
      const anchor = root.querySelector('.jdgm-all-reviews-text > a');
      if (!rating || !score || !text || !anchor) return;
      const average = Number(rating.dataset.score);
      const count = Number(text.dataset.numberOfReviews);
      if (!Number.isFinite(average) || average <= 0 || !Number.isInteger(count) || count <= 0) return;
      const value = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(average);
      const total = new Intl.NumberFormat('de-DE').format(count);
      const scoreText = `${value} / 5`;
      const countText = `${total} ${root.dataset.countLabel}`;
      if (score.textContent !== scoreText) score.textContent = scoreText;
      if (text.textContent !== countText) text.textContent = countText;
      if (root.dataset.reviewsLink && anchor.getAttribute('href') !== root.dataset.reviewsLink) anchor.setAttribute('href', root.dataset.reviewsLink);
      const label = `${scoreText}. ${countText}. ${root.dataset.linkLabel}`;
      if (anchor.getAttribute('aria-label') !== label) anchor.setAttribute('aria-label', label);
    };
    new MutationObserver(refresh).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-score', 'data-number-of-reviews'] });
    refresh();
  }
  document.querySelectorAll('.hg-home-trust').forEach(hgHomeReviewCounter);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.hg-home-trust').forEach(hgHomeReviewCounter));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-jewelry-launch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hg-jewelry-gallery')) {
  customElements.define('hg-jewelry-gallery', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('slider-element').then(() => {
        if (!this.isConnected || this.resize) return;
        const slider = this.querySelector('slider-element');
        this.resize = new ResizeObserver(() => {
          if (!slider.initialized) return;
          if (slider.itemOffset > 0) slider.update();
          else { slider.currentPage = 1; slider.updateButtons(); }
          slider.updateTabindex();
        });
        this.resize.observe(slider);
      });
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.resize = null;
    }
  });
}
if (!customElements.get('hg-jewelry-stories')) {
  customElements.define('hg-jewelry-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.hg-jl__gift-grid');
      this.cards = [...this.track.children];
      this.controls = this.querySelector('[data-story-controls]');
      this.previous = this.querySelector('[data-story-prev]');
      this.next = this.querySelector('[data-story-next]');
      this.position = this.querySelector('[data-story-position]');
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('scroll', () => this.update(), {...options, passive: true});
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || event.ctrlKey || event.metaKey || event.altKey) return;
        const destinations = {ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.cards.length - 1};
        if (!(event.key in destinations) || this.controls.hidden) return;
        event.preventDefault();
        this.go(destinations[event.key]);
      }, options);
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.controls.hidden) return;
        this.drag = {x: event.clientX, y: event.clientY, left: this.track.scrollLeft, id: event.pointerId, active: false};
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;
        if (!this.drag.active) {
          if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) {this.drag = null; return;}
          if (Math.abs(dx) < 7) return;
          this.drag.active = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - dx;
      }, options);
      const finish = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const active = this.drag.active;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        if (active) {this.ignoreClickUntil = Date.now() + 250; this.update(); this.go(this.index);}
      };
      this.track.addEventListener('pointerup', finish, options);
      this.track.addEventListener('pointercancel', finish, options);
      this.track.addEventListener('pointerleave', () => {if (this.drag && !this.drag.active) this.drag = null;}, options);
      this.track.addEventListener('click', event => {
        if (Date.now() < (this.ignoreClickUntil || 0)) {event.preventDefault(); event.stopImmediatePropagation();}
      }, {...options, capture: true});
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    offsets() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const first = this.cards[0]?.offsetLeft || 0;
      return this.cards.map(card => Math.min(max, Math.max(0, card.offsetLeft - first)));
    }
    update() {
      const offsets = this.offsets();
      const left = this.track.scrollLeft;
      this.index = offsets.reduce((best, value, index) => Math.abs(value - left) < Math.abs(offsets[best] - left) ? index : best, 0);
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
      this.toggleAttribute('data-scrollable', scrollable);
      this.controls.hidden = !scrollable;
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index >= this.cards.length - 1;
      const label = `${this.index + 1} / ${this.cards.length}`;
      if (this.position.textContent !== label) this.position.textContent = label;
    }
    go(index) {
      index = Math.max(0, Math.min(this.cards.length - 1, index));
      this.track.scrollTo({left: this.offsets()[index], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.abort = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-reviews-story"] && !Shopify.designMode) return;
  try {
    
  function hgFormatReviewNumbers(root) {
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de');
    root.querySelectorAll('[data-hg-review-number]').forEach(element => {
      const value = Number(element.textContent.trim());
      if (Number.isInteger(value) && value >= 0) element.textContent = formatter.format(value);
    });
  }
  hgFormatReviewNumbers(document);
  document.addEventListener('shopify:section:load', event => hgFormatReviewNumbers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-text"] && !Shopify.designMode) return;
  try {
    
  const initializeMarqueeControls = () => {
    document.querySelectorAll('[data-hg-marquee-pause]').forEach((button) => {
      button.hidden = false;
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hg-marquee-pause]');
    if (!button) return;
    const marquee = button.closest('[data-hg-home-marquee]');
    if (!marquee) return;
    const paused = marquee.dataset.hgMarqueePaused !== 'true';
    marquee.dataset.hgMarqueePaused = String(paused);
    button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMarqueeControls, { once: true });
  } else {
    initializeMarqueeControls();
  }
  document.addEventListener('shopify:section:load', initializeMarqueeControls);

  } catch(e) { console.error(e); }
})();
})();
